function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as S from './DialogButton.styles';
const DialogButton = ({
  children,
  variant = 'borderless',
  size = 'md',
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(S.Root, _extends({
    variant: variant,
    size: size,
    disabled: Boolean(rest.disabled)
  }, rest), children);
};
export default DialogButton;